import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { UtilService } from 'src/app/service/util.service';
import { Constants } from 'src/app/constants/constants';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ToastService } from 'src/app/service/toast.service';

@Component({
  selector: 'app-location-list-template',
  templateUrl: './location-list-template.component.html',
  styleUrls: ['./location-list-template.component.scss']
})
export class LocationListTemplateComponent implements OnInit {

  @Input()
  locationList: Array<any>;

  @ViewChild('addLocationForm', { static: true }) public addLocationForm: NgForm;

  locationFormData: any = {};
  stateList: Array<any> = [];
  invalidZipCode: boolean = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.initLocationFormData();
    this.getStateList();
  }

  initLocationFormData() {
    this.locationFormData = {
      "id": null,
      "address": {
        "city": null,
        "country": null,
        "name": null,
        "state": null,
        "street": null,
        "zipCode": null
      },
      "type": "FACILITY",
      "coordinate": {
        "latitude": null,
        "longitude": null
      }
    }
  }

  updateLocationClick(location) {
    console.log("update location clicked: ", location);
    this.initLocationFormData();
    this.locationFormData.id = location.id
    this.locationFormData.address.city = location.address.city;
    this.locationFormData.address.country = location.address.country;
    this.locationFormData.address.name = location.address.name;
    this.locationFormData.address.state = location.address.state;
    this.locationFormData.address.street = location.address.street;
    this.locationFormData.address.zipCode = location.address.zipCode;
    if (location.coordinate) {
      this.locationFormData.coordinate.latitude = location.coordinate.latitude;
      this.locationFormData.coordinate.longitude = location.coordinate.longitude;
    }

    document.getElementById("updateLocation").click();
  }

  resetLocationForm() {
    console.log("reset location form");
    if (this.addLocationForm) {
      this.addLocationForm.reset();
      this.addLocationForm.resetForm();
      setTimeout(() => {
        this.initLocationFormData();
      }, 500);
    }
  }

  updateLocation(locationId, payload) {
    this.utilService.showSpinner();
    this.apiService.updateLocation(locationId, payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("response : ", data);
      this.toast.showSuccess("Location updated successfully");
      document.getElementById("closeAddLocationModal").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateLocation(locationId, payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });

  }

  getStateList() {
    this.utilService.showSpinner();
    this.apiService.getUsStateList().then((data) => {
      this.utilService.hideSpinner();
      this.stateList = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getStateList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });

  }

  getZipCodeDetails(zipCode) {
    if (zipCode.length == 5) {
      this.apiService.getZipCodeDetails(zipCode).then((data) => {
        this.invalidZipCode = false;
        console.log("zip code detail data from api : ", data);
        this.locationFormData.address.state = data.places[0]["state abbreviation"];
        this.locationFormData.address.city = data.places[0]["place name"];
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_NOT_FOUND) {
          this.invalidZipCode = true;
        } else if (error && error.error && error.error.message) this.toast.showError(error.error.message);
      });
    } else {
      this.invalidZipCode = false;
      this.locationFormData.address.state = null;
      this.locationFormData.address.city = null;
    }

  }

  onCreateLocation(form: NgForm) {
    if (form.valid) {

      // If any one of lat/long is null return.
      if ((!isNullOrUndefined(this.locationFormData.coordinate.latitude) &&
        isNullOrUndefined(this.locationFormData.coordinate.longitude)) ||
        (isNullOrUndefined(this.locationFormData.coordinate.latitude) &&
          !isNullOrUndefined(this.locationFormData.coordinate.longitude))) {
        return;
      }

      var payload = JSON.parse(JSON.stringify(this.locationFormData));
      payload.address.state = this.locationFormData.address.state.toUpperCase();
      payload.address.city = this.utilService.toTitleCase(this.locationFormData.address.city);
      console.log("form data : ", payload);
      if (isNullOrUndefined(payload.coordinate.latitude)) {
        payload.coordinate = null;
      }

      console.log("Update location : ", this.locationFormData.id)
      this.updateLocation(this.locationFormData.id, payload);
    }
  }

}
